module.exports = __webpack_public_path__ + "static/media/businessman.b223f306.svg";